const STORAGE_KEY = "wifiads.referralAttribution";
const ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;

export function captureReferralAttribution() {
  const queryCode = new URLSearchParams(window.location.search).get("ref");
  if (queryCode) {
    const code = queryCode.trim().toUpperCase();
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ code, storedAt: Date.now() })
    );
    return code;
  }

  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored?.code && Date.now() - stored.storedAt < ATTRIBUTION_TTL) {
      return stored.code;
    }
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY);
  }

  localStorage.removeItem(STORAGE_KEY);
  return "";
}

export function clearReferralAttribution() {
  localStorage.removeItem(STORAGE_KEY);
}
